import { useWeb3Auth } from "@web3auth/modal-react-hooks";
import { useState } from "react";
import { IconComponent } from "@/ui/icon";
import AccountSettingsModal from "../account-settings-modal/account-settings-modal";
import GradientBorderRadius from "@/ui/gradient-border-radius";

const AccountControls = () => {
  const { isConnected } = useWeb3Auth();
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!isConnected) {
    return null;
  }

  return (
    <>
      <div className="flex gap-[0.6250rem]">
        <GradientBorderRadius
          radius="circle"
          className="w-[2rem] h-[2rem] flex items-center justify-center"
          gradient="50"
          hover="r-100"
          onClick={() => {
            setIsModalOpen(true);
          }}
        >
          <IconComponent name="settings" className="w-[1rem] h-[1rem]" />
        </GradientBorderRadius>
      </div>
      {isModalOpen && (
        <AccountSettingsModal
          onClose={() => {
            setIsModalOpen(false);
          }}
          onConfirm={() => {
            setIsModalOpen(false);
          }}
        />
      )}
    </>
  );
};

export default AccountControls;
